module.exports = {
  apiHost: "https://api.carolina.sensoreal.com.au",
  assetsHost: "https://assets.carolina.sensoreal.com.au",
  formTemplate: "default",

  header: {
    logo: "",
    text: {
      en: "Your Carolina Selections",
      ar: "",
    },
    color: "#fff",
  },
  footerLogo:
    "https://static-mbh.sgp1.cdn.digitaloceanspaces.com/avid-edm/general/AVID_White_72dpi.png",
  contact: {
    address:
      "Corner Sinclairs Road & Taylors Road<br>(Entrance Via Sinclairs Road)<br>Deanside, 3335",
    email: "carolina@avid.com.au",
    phone: "1800 875 597",
    website: "https://carolina.avid.com.au",
  },
  links: {
    instagram: "https://www.instagram.com/avid_together/",
    facebook: "https://www.facebook.com/carolinadeanside/",
    linkedin: "https://au.linkedin.com/company/avid-property-group",
    privacy: "https://avid.com.au/privacy-policy",
    twitter: "",
    youtube: "https://www.youtube.com/channel/UCEnh4QABTOnsovDd-Hg45OQ",
  },
  style: {
    primaryColor: "#00AFD7",
    textColor: "#fff",
  },
};
